import styled from '@emotion/styled';
import { Accordion } from 'react-bootstrap';

import colors from 'resources/styles/colors';

export const Menu = styled.div`
  width: 16rem;
  min-width: 16rem;
`;

export const MenuItem = styled.div`
  display: block;
  padding: 1rem 1.25rem;
  border: 1px solid ${colors.gray};
  border-top: none;
  color: ${colors.primaryColor};
  text-decoration: none;

  &:first-of-type {
    border-top: 1px solid ${colors.gray};
  }

  &:hover {
    background-color: ${colors.lightGray};
  }

  &:hover[href] {
    text-decoration: underline;
  }
`;

export const MenuItemBody = styled.div`
  color: ${colors.darkGray};
`;

export const activeStyle = {
  borderColor: colors.primaryColor,
  backgroundColor: colors.primaryColor,
  color: colors.lightGray,
  fontWeight: 600,
};

export const AccordionItem = styled(Accordion.Item)`
  border: none;
`;

export const AccordionHeader = styled(Accordion.Header)`
  padding: 0;
  border: 1px solid ${colors.gray};
  border-top: none;
  outline: none;

  button:focus {
    box-shadow: none;
  }
`;

export const AccordionBody = styled(Accordion.Body)`
  padding: 0;
  border: none;
  borderradius: 0;

  a:first-of-type {
    border-top: none;
  }
`;
